import { withAppHOC } from "../../hoc";
import { StyledPageHeading, StyledPageBody } from "../../components/Styled";

const Process = () => {
  return (
    <>
      <StyledPageHeading>
        <h1>Process</h1>
      </StyledPageHeading>
      <StyledPageBody>
        <p>
          At Nature's Fresh Farm, we are deeply committed to sustainable and
          responsible farming practices that honor nature and deliver the
          highest quality products to our customers. Located in Hyderabad,
          India, our farm is dedicated to raising animals in a way that
          prioritizes their well-being, while also producing milk and eggs that
          are naturally rich, fresh, and nutritious.
        </p>
        <h2>Unique Farming Approach</h2>
        <p>
          Our farming methods are inspired by traditional practices, combined
          with modern advancements to ensure the health of our animals and the
          environment. Here's what sets Nature's Fresh Farm apart:
        </p>
        <ol>
          <li>
            <h3>Free-Range and Pasture-Raised Animals</h3>
            <p>
              We believe that animals should be able to roam freely and graze on
              natural pastures. Our chickens and cows enjoy open spaces,
              allowing them to graze and peck naturally. This not only keeps our
              animals happy and healthy but also enhances the nutritional
              profile of our eggs and milk.
            </p>
          </li>
          <li>
            <h3>Organic Feed and Natural Diet</h3>
            <p>
              Our animals are fed a balanced diet made up of natural, organic
              ingredients free from chemicals and artificial additives. By
              focusing on clean, wholesome feed, we ensure our products are rich
              in nutrients and free from harmful substances.
            </p>
          </li>
          <li>
            <h3>Eco-Friendly Practices</h3>
            <p>
              We are committed to reducing our environmental impact by using
              sustainable practices, such as rainwater harvesting, composting,
              and rotational grazing. We also minimize the use of plastics on
              our farm and prioritize recyclable and biodegradable packaging for
              all our products.
            </p>
          </li>
        </ol>
      </StyledPageBody>
    </>
  );
};

export default withAppHOC(Process);
